// baseURL:'http://localhost:8081/api/',//前端开启代理时，用这个接口
//baseURL:'http://localhost:8080/employee-sports-service/api/',//后台处理跨域时，用这个接口
//baseURL:'https://hd.zhihuisports.com/employee-sports-service/api/',//环境中

// export const baseUrl='http://localhost:8080/employee-sports-service/api/';
export const baseUrl='https://hd.zhihuisports.com/employee-sports-service/api/';//环境中
